"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./ModalCloseHeader.css");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _exitIcon3x = _interopRequireDefault(require("../../../../images/shared/icons/exitIcon@3x.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalCloseHeader = function ModalCloseHeader(_ref) {
  var _ref$closeModal = _ref.closeModal,
      closeModal = _ref$closeModal === void 0 ? function () {} : _ref$closeModal;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-2020-close-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: closeModal
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _exitIcon3x.default,
    alt: "close"
  })));
};

var func = _propTypes.default.func;
ModalCloseHeader.propTypes = {
  closeModal: func
};
var _default = ModalCloseHeader;
exports.default = _default;